import React from "react";
import Link from "components/link";
import Image from "components/image";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import { ReactComponent as DirectionalArrow } from "svgs/navigation-arrow.svg";
import clsx from "clsx/lite";

const BlogPosts = ({ data }) => {
	const isFluid = data?.settings?.isFluid;

	return (
		<div className="w-full flex justify-center">
			<div className="flex-center flex-col w-full gap-8 standard-section-width">
				<div
					className={clsx("flex justify-between flex-col gap-3 md:flex-row w-full", isFluid && "horizontal-padding")}>
					<h2>{data.title}</h2>
					{data.link ?
						<Link to={data?.link.url} className="group flex gap-4 items-center">
							<p className={
								clsx("group-hover:text-beige group-hover:pr-1 transition-all",
									"duration-300 text-base font-semibold")}>
								{data?.link.title}
							</p>
							<DirectionalArrow className="fill-beige group-hover:scale-x-110 transition-all duration-300" />
						</Link>
						: null}
				</div>
				<div className={clsx("flex flex-col md:flex-row gap-6 w-full", isFluid && "sm:px-4 xl:px-5")}>
					<Link to={`/blogs/${data.blogs[0].category.handle}/${data?.blogs[0].handle}`}
						className={clsx("group w-fit md:w-1/2 flex flex-col gap-3 md:gap-5", isFluid && "px-4 sm:px-0")}>
						<Image className="md:aspect-[10/4]" image={data.blogs[0].featuredImage} />
						<div className="flex flex-col gap-3">
							<div className="flex items-center justify-between">
								<h5 className="line-clamp-1 font-base font-semibold">{data.blogs[0].title}</h5>
								<Arrow className="group-hover:fill-beige group-hover:pl-1 transition-all duration-300" />
							</div>
							<p className="hidden text-secondary text-base md:line-clamp-3">{data.blogs[0].excerpt}</p>
						</div>
					</Link>
					<div className={
						clsx("w-full flex justify-start md:w-1/2 md:flex-col gap-4 md:gap-0 overflow-auto no-scrollbar",
							isFluid && "px-4 sm:px-0")}
					>
						{data.blogs.slice(1).map((blog, index) => (
							<Link key={index} to={`/blogs/${blog.category.handle}/${blog.handle}`}
								className={
									clsx("flex group md:h-fit flex-col md:flex-row gap-3 md:gap-5 md:py-2.5",
										"first:pt-0 last:pb-0 md:border-b last:border-b-0")}>
								<div className="min-w-[150px] md:min-w-min md:w-[19%] aspect-square">
									<Image className="group-hover:scale-105 transition-all duration-300 h-full"
										image={blog.featuredImage} />
								</div>
								<div className="w-full md:w-4/5 flex flex-col justify-center gap-2">
									<div className="flex items-center justify-between">
										<h5 className="w-5/6 line-clamp-1 font-base font-semibold">{blog.title}</h5>
										<Arrow className="group-hover:fill-beige group-hover:pl-1 transition-all duration-300" />
									</div>
									<p className="hidden md:line-clamp-2 text-base text-secondary">{blog.excerpt}</p>
								</div>
							</Link>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BlogPosts;